/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取图形验证码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GraphicCaptchaParams {
  constructor(public length?: number) {}
}

export default async function (
  params: GraphicCaptchaParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.GraphicCaptchaDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/setting/graphic-captcha`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
